import React, { useState, useEffect } from 'react';
import { Input, Select, FormGroup, Textarea } from '../components/Form';
import { getAgendadores, submitDiarioSocialSeller } from '../services/api';
import { logError } from '../lib/logError';
import { hojeSP } from '../lib/tz';


const INITIAL = {
    data: hojeSP(),
    nome: '',
    abordagens_novos_contatos: '',
    retorno: '',
    follow_up: '',
    aprendizados: '',
    desafios: '',
};

function DiarioSocialSeller() {
    const [sellers, setSellers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState(INITIAL);

    useEffect(() => {
        setIsLoading(true);
        getAgendadores()
            .then(data => setSellers(data.filter(m => m.cargo?.trim().toLowerCase() === 'social seller')))
            .catch(err => { logError(err, { page: 'DiarioSocialSeller' }); setErrorMessage('Não foi possível carregar a lista de Social Sellers.'); })
            .finally(() => setIsLoading(false));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleNumberChange = (e) => {
        const { name, value } = e.target;
        if (value === '' || /^\d+$/.test(value)) setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSuccessMessage('');
        setErrorMessage('');
        try {
            const payload = {
                ...formData,
                abordagens_novos_contatos: parseInt(formData.abordagens_novos_contatos) || 0,
                retorno: parseInt(formData.retorno) || 0,
                follow_up: parseInt(formData.follow_up) || 0,
            };
            const response = await submitDiarioSocialSeller(payload);
            if (response.success) {
                setSuccessMessage('Diário de Social Seller registrado com sucesso!');
                setFormData({ ...INITIAL, data: hojeSP() });
                window.scrollTo(0, 0);
            } else {
                setErrorMessage(response.error || 'Ocorreu um erro ao enviar o diário.');
            }
        } catch (error) {
            setErrorMessage(error?.message || 'Erro ao enviar o diário.');
            window.scrollTo(0, 0);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className="page-header">
                <div className="page-header-left">
                    <div>
                        <div className="page-kicker">Diário</div>
                        <h1 className="page-title">Diário Social Seller</h1>
                    </div>
                </div>
                <div className="page-header-right">
                    <span className="chip chip-muted">{formData.data || 'hoje'}</span>
                </div>
            </div>

            <div className="page-body">
                {successMessage && <div className="alert alert-success">{successMessage}</div>}
                {errorMessage && <div className="alert alert-error">{errorMessage}</div>}

                <form onSubmit={handleSubmit}>
                    {/* Identificação */}
                    <div className="card" style={{ marginBottom: '1.25rem' }}>
                        <p className="section-label">Identificação</p>
                        <div className="grid-2">
                            <FormGroup label="Data" htmlFor="data">
                                <Input type="date" id="data" name="data" value={formData.data} onChange={handleChange} required />
                            </FormGroup>
                            <FormGroup label="Nome do Social Seller" htmlFor="nome">
                                <Select id="nome" name="nome" value={formData.nome} onChange={handleChange} required isLoading={isLoading}>
                                    <option value="">Selecione o Social Seller</option>
                                    {sellers.map(s => <option key={s.nome} value={s.nome}>{s.nome}</option>)}
                                </Select>
                            </FormGroup>
                        </div>
                    </div>

                    {/* Métricas */}
                    <div className="card" style={{ marginBottom: '1.25rem' }}>
                        <p className="section-label">Métricas de Prospecção</p>
                        <div className="grid-3">
                            <FormGroup label="Abordagens (Novos)" htmlFor="abordagens_novos_contatos">
                                <Input type="number" min="0" id="abordagens_novos_contatos" name="abordagens_novos_contatos" value={formData.abordagens_novos_contatos} onChange={handleNumberChange} placeholder="0" required />
                            </FormGroup>
                            <FormGroup label="Retornos de abordagens" htmlFor="retorno">
                                <Input type="number" min="0" id="retorno" name="retorno" value={formData.retorno} onChange={handleNumberChange} placeholder="0" required />
                            </FormGroup>
                            <FormGroup label="Follow-up" htmlFor="follow_up">
                                <Input type="number" min="0" id="follow_up" name="follow_up" value={formData.follow_up} onChange={handleNumberChange} placeholder="0" required />
                            </FormGroup>
                        </div>
                    </div>

                    {/* Reflexão */}
                    <div className="card">
                        <p className="section-label">Reflexão</p>
                        <FormGroup label="Aprendizados do Dia" htmlFor="aprendizados">
                            <Textarea id="aprendizados" name="aprendizados" value={formData.aprendizados} onChange={handleChange} placeholder="Descreva os principais aprendizados ou observações do dia..." rows={4} required />
                        </FormGroup>
                        <FormGroup label="Desafios do Dia" htmlFor="desafios">
                            <Textarea id="desafios" name="desafios" value={formData.desafios} onChange={handleChange} placeholder="Quais os principais desafios enfrentados hoje?" rows={4} required />
                        </FormGroup>
                        <div className="form-footer">
                            <button type="submit" className="pill pill-primary" disabled={isSubmitting}>
                                {isSubmitting ? 'Registrando...' : 'Registrar Diário Social Seller'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default DiarioSocialSeller;
